module.exports = __webpack_public_path__ + "media/images/sports_coaching/main_image2@3x-be9707c0b11427eebea0d820c7f6548f.jpg";